@if(!isMoreDetails) {
<div class="bg-white p-0 root-div d-flex flex-column gap-3">
  @if (isLoading) {
  <app-loading class="h-100 loading-container" [text]="'Loading'"></app-loading>
  } @else {
  <ng-container *ngIf="result && chartData.length > 0; else noDataTemplate">
    <div class="top-summary-card d-flex flex-row justify-content-between">
      <app-summary-data-card [item]="parentCard" (onDownload)="downloadExcel($event)" class="total">
      </app-summary-data-card>

      @for(card of topCardList;track card?.name; let i =
      $index){
      <ng-container>
        <div class="vertical-divider"></div>
        <app-summary-data-card [item]="card" (onDownload)="downloadExcel($event)"
          class="topCard"></app-summary-data-card>
      </ng-container>
      }
    </div>
    <div class="border Pre-optimized ">
      <div class="card-header ps-4">Pre Optimized Test Case Classification</div>
      <div class="d-flex flex-row justify-content-between gap-3 middle-card">
        <div class="m-4 d-flex flex-column card-2 summary- w-100">
          <div class="flex-row sum-card w-100">
            @for(card of middleCardList;track card?.name; let i =
            $index){
            <div class="summary-card-box w-100 h-50 p-2" [ngClass]="'card-color-' + (i + 1)">
              <app-summary-data-card [item]="card" (onDownload)="downloadExcel($event)"
                (onCardSelect)="onExpand($event)" class="w-50"></app-summary-data-card>
            </div>
            @if (i < middleCardList.length - 1) { } } </div>

              <div class="d-flex flex-column w-100 duplicate-div">
                <div class="d-flex flex-column justify-content-between">
                  <div class="duplicate">
                    <div class="d-flex flex-row align-items-center mb-3 w-100 justify-content-between">
                      <span class="accello-general-text16">Duplicate Test Cases</span>
                      <img src="assets/images/virtusa-icons/card-expand-icon.svg" alt="download"
                        (click)="onExpand('duplicate')" (keydown.enter)="onExpand('duplicate')" />
                    </div>
                    <span class="header-num">{{ result?.duplicateTestcaseCount }}</span>
                    <img src="assets/images/virtusa-icons/download-icon.svg" alt="download"
                      (click)="downloadExcel('duplicate')" (keydown.enter)="downloadExcel('duplicate')" />
                  </div>
                  <div class="d-flex flex-row align-items-center w-100 justify-content-between distitnct">
                    <div>
                      <span class="accello-general-text16">Distinct Test Cases From Duplicates</span>
                      <img src="assets/images/virtusa-icons/circle-i.png" alt="info" class="info-icon" />
                    </div>
                    <div>
                      <span class="header-num"> {{ duplicateCard?.uniqueInduplicate?.value }}</span>
                      <img src="assets/images/virtusa-icons/download-icon.svg" alt="download"
                       (click)="downloadExcel('unique-from-duplicates')" (keydown.enter)="downloadExcel('unique-from-duplicates')" />
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <div class="m-4 top-card card-2">
            <div class="d-flex flex-column justify-content-between">
              <div class="d-flex flex-row align-items-center mb-3">
                <span class="header-14">{{
                  chartData[0]?.metricDisplayName
                  }}</span>
                <span matTooltip="{{ chartData[0]?.info }}" matTooltipPosition="below">
                  <img src="assets/images/virtusa-icons/circle-i.png" alt="info" class="info-icon" />
                </span>
              </div>
              <!-- <div>
            <span class="header-num">{{ chartData[0]?.value }}</span>
            
            <img
              src="assets/images/virtusa-icons/download-icon.svg"
              alt="download"
              (click)="downloadExcel(chartData[0]?.type)"
            />
          </div> -->
            </div>
            <div class="chart-div">
              <app-pie-chart class="tco-chart" [chartType]="'pie'" [meta]="{
              isLegendVisible: false
            }" [data]="chartData[0]?.data" [backgroundColors]="chartData[0]?.bgColors"
                [showValueOnly]="false"></app-pie-chart>
              <div class="custom-legend">
                <div class="legend-item d-flex justify-content-between"
                  *ngFor="let item of chartData[0]?.data; let i = index">
                  <div>
                    <span class="legend-color-box" [style.background-color]="chartData[0]?.bgColors[i]"></span>
                    <span class="legend-label ps-1">{{ item.label }}</span>
                  </div>
                  <div>
                    <span class="legend-percentage">
                      {{ calculatePercentage(item.value, 0) | number: '1.0-0' }}%
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="border">
        <div class="card-header ps-4">Optimized Test Set</div>
        <div class="d-flex flex-row justify-content-between gap-3 middle-card">
          <div class="m-4 top-card col-md-6 card-2">
            <div class="d-flex flex-row align-items-center mb-3 w-100 justify-content-between">
              <div class="d-flex">
                <span class="header-14">{{
                  chartData[1]?.metricDisplayName
                  }}</span>
                <span matTooltip="{{ chartData[1]?.info }}" matTooltipPosition="below">
                  <img src="assets/images/virtusa-icons/circle-i.png" alt="info" class="info-icon" />
                </span>
              </div>
              <div>
                <span class="header-num">{{ chartData[1]?.value }}</span>

                <img src="assets/images/virtusa-icons/download-icon.svg" alt="download"
                  (click)="downloadExcel(chartData[1]?.type)" (keydown.enter)="downloadExcel(chartData[1]?.type)" />
              </div>
            </div>
            <div class="chart-div">
              <app-pie-chart class="tco-chart" [chartType]="'pie'" [name]="" [meta]="{ isLegendVisible: false }"
                [data]="chartData[1]?.data" [backgroundColors]="chartData[1]?.bgColors" [showValueOnly]="true"
               ></app-pie-chart>
              <div class="custom-legend">
                <div class="legend-item d-flex justify-content-between"
                  *ngFor="let item of chartData[1]?.data; let i = index">
                  <div>
                    <span class="legend-color-box" [style.background-color]="chartData[1]?.bgColors[i]"></span>
                    <span class="legend-label ps-1">{{ item.label }}</span>
                  </div>
                  <div>
                    <span class="legend-percentage">
                      {{ item.value }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="m-4 top-card col-md-6 card-2">
            <div class="d-flex flex-column">
              <div class="d-flex flex-row mb-3">
                <span class="header-14">{{
                  chartData[2]?.metricDisplayName
                  }}</span>
                <span matTooltip="{{ chartData[2]?.info }}" matTooltipPosition="below">
                  <img src="assets/images/virtusa-icons/circle-i.png" alt="info" class="info-icon" />
                </span>
              </div>
              <!-- <span class="header-num" *ngIf="chartData[2]?.value">{{ chartData[2]?.value }}%</span> -->
            </div>
            <div class="chart-div-2">
              <app-pie-chart class="tco-chart" [chartType]="'doughnut'" [name]="" [meta]="{ isLegendVisible: false }"
                [data]="chartData[2]?.data" [backgroundColors]="chartData[2]?.bgColors"
               ></app-pie-chart>
              <div class="custom-legend">
                <div class="legend-item d-flex justify-content-between"
                  *ngFor="let item of chartData[2]?.data; let i = index">
                  <div>
                    <span class="legend-color-box" [style.background-color]="chartData[2]?.bgColors[i]"></span>
                    <span class="legend-label ps-1">{{ item.label }}</span>
                  </div>
                  <div>
                    <span class="legend-percentage">{{ calculatePercentage(item.value, 2) | number: '1.0-0' }}%</span>
                  </div>
                </div>
              </div>


              <div class="custom-text d-flex flex-column gap-3 my-3 overlay-content-2" *ngIf="!isObsolete">
                <!-- <span>{{ percentageChartLegend }} -->
                <span class="general-text-16"> A repository containing <span
                    class="header-11">{{result?.totalTestCasesCount}}</span> test cases have been optimized by <span
                    class="header-11">{{optimizedPercentage}}%</span>, with the identification of <span
                    class="header-11">{{totalUniqueTestCount}}</span>
                  unique test cases </span>
              </div>
              <div class="custom-text d-flex flex-column gap-3 my-3 overlay-content-2" *ngIf="isObsolete">
                <!-- <span>{{ percentageChartLegend }} -->
                <span class="general-text-16"> A repository containing <span
                    class="header-11">{{totalCountWithObsolete}}</span> test cases have been optimized by <span
                    class="header-11">{{optimizedPercentage}}%</span>,
                  with the identification of <span class="header-11">{{totalUniqueTestCountWhenObsolete}}</span>
                  actionable test cases </span>
              </div>
            </div>

          </div>
        </div>
      </div>
  </ng-container>

  <ng-template #noDataTemplate>
    <app-no-data></app-no-data>
  </ng-template>

  }
</div>
} @else {
<select class="form-select" [(ngModel)]="viewTypeMoreDetails" (change)="changeViewType()">
  <option [value]="item.value" *ngFor="let item of moreDetailsItems">
    {{ item.label }}
  </option>
</select>
<div class="result-wrapper">
  <ng-container [ngSwitch]="viewTypeMoreDetails">
    <app-duplicate-test-cases [modelId]="modelId" [uniqueFromDuplicateIds]="uniqueFromDuplicateIds" *ngSwitchCase="'duplicate'" (moveToPreviousTabEvent)="handleBackFromDetails()"></app-duplicate-test-cases>
    <app-unique-test-cases [modelId]="modelId" *ngSwitchCase="'unique'" [data]="uniqueTestcasesList"(moveToPreviousTabEvent)="handleBackFromDetails()">
    </app-unique-test-cases>
    <app-potential-overlap-test-cases [modelId]="modelId" *ngSwitchCase="'overlapping'"(moveToPreviousTabEvent)="handleBackFromDetails()">
    </app-potential-overlap-test-cases>
  </ng-container>
</div>
}